import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBranchList } from "../action/BranchAction";

export default function Branch() {
  const dispatch = useDispatch();
  const { loading, error, branchRecords } = useSelector(
    (s) => s.branchList
  );

  const getBranches = () => {
    dispatch(getBranchList());
  };

  useEffect(() => {
    if (!branchRecords) {
        getBranches();
    }
  }, [dispatch, branchRecords]);

  return branchRecords ? branchRecords.map(rec=>(
    <option key={rec.Id} value={rec.Id}>{rec.Branch}</option>
  )) : (
    <option value="">No Record Exist!</option>
  );
}
